export { HeroRender } from './HeroRender';
